export default __webpack_public_path__ + "static/media/adawms_logo.baf9261c.png";